<template>
  <section class="focus padding">
    <div class="container">
      <div class="row">
        <div class="col-4 animation a-translateY">
          <div class="col-4__body">
            <h2 v-if="HEADER_LANG === 'en'">Our Focus</h2>
            <h2 v-if="HEADER_LANG === 'ru'">Наши приоритеры</h2>
            <p v-if="HEADER_LANG === 'en'">SolarBox's core focus includes:</p>
            <p v-if="HEADER_LANG === 'ru'">SolarBox основное внимание уделяет:</p>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-1">
          <div class="col-4__body">
            <h3 v-if="HEADER_LANG === 'en'">Sustainable Profits</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Устойчивой прибыли</h3>
            <picture>
              <source srcset="../../public/static/images/home/3.webp">
              <img src="../../public/static/images/home/3.jpg" alt="">
            </picture>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-2">
          <div class="col-4__body">
            <h3 v-if="HEADER_LANG === 'en'">Sustainable Infrastructure</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Устойчивой инфраструктуре</h3>
            <picture>
              <source srcset="../../public/static/images/home/4.webp">
              <img src="../../public/static/images/home/4.jpg" alt="">
            </picture>
          </div>
        </div>
        <div class="col-4 animation a-translateY">
          <div class="col-4__body">
            <h3 v-if="HEADER_LANG === 'en'">Sustainable Environment</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Устойчивой окружающей среде</h3>
            <picture>
              <source srcset="../../public/static/images/home/5.webp">
              <img src="../../public/static/images/home/5.jpg" alt="">
            </picture>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-1">
          <div class="col-4__body">
            <h3 v-if="HEADER_LANG === 'en'">Sustainable Technology</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Устойчивым технологиям</h3>
            <picture>
              <source srcset="../../public/static/images/home/6.webp">
              <img src="../../public/static/images/home/6.jpg" alt="">
            </picture>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-2">
          <div class="col-4__body">
            <h3 v-if="HEADER_LANG === 'en'">Sustainable Communities</h3>
            <h3 v-if="HEADER_LANG === 'ru'">Устойчивому сообществу</h3>
            <picture>
              <source srcset="../../public/static/images/home/7.webp">
              <img src="../../public/static/images/home/7.jpg" alt="">
            </picture>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SectionFocus',
  components: {
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

//
.focus {
  background-color: $cBlack;
  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex: 0 0 auto;
    margin-bottom: 0 -10px;
    height: auto;
    position: relative;
    @media (max-width: 767.98px) {
      margin: 0;
    }
    .col-4 {
      flex: 0 0 33.333%;
      max-width: 33.333%;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 10px;
      overflow: hidden;
      margin-bottom: 20px;
      &__body {
        box-sizing: border-box;
        position: relative;
        max-width: 100%;
        width: 100%;
        height: 100%;
      }
      &:first-child {
        .col-4__body {
          background-color: $cBlack;
          border: 10px solid $cYellow;
          color: $cWhite;
          padding: 20px;
          h2 {
            padding-bottom: 20px !important;
            margin-bottom: 20px !important;
            &:after {
              background-color: $cRed;
              width: 80%;
            }
          }
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      h3 {
        color: $cWhite;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: $cBlack;
        max-width: 270px;
        padding: 28px 28px 10px 0;
      }
      @media (max-width: 1199.98px) {
        flex: 0 0 50%;
        max-width: 50%;
      }
      @media (max-width: 767.98px) {
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0;
        img {
          max-height: 200px;
        }
        h3 {
          max-width: 230px;
          padding: 14px 14px 5px 0;
        }
      }
    }
  }
}
</style>
